import { List } from "@mui/material";
import { GeoJsonGeometryType, PointRoadFeature} from "../../../services/RuteplanAPI";
import { useRouteHighlightActions } from "../../../stores/RouteHighlightStore";
import BomstasjonListItem from './BomstasjonerListItem';
import RasteplassListItem from './RasteplassListItem';
import VegkameraListItem from "./VegkameraListItem";
import HeightListItem from './HeightListItem';
import DognhvileplassListItem from './DognhvileplassListItem';
import LengthListItem from './LengthListItem';
import TuristvegListItem from './TuristvegListItem';
import WeightListItem from './WeightListItem';
import FergeListItem from './FergeListItem';
import LadestasjonListItem from './LadestasjonListItem';
import TrafficMessageListItem from './TrafficMessageListItem';
import SwedishTrafficMessageListItem from './SwedishTrafficMessageListItem';
import FinnishTrafficMessageListItem from './FinnishTrafficMessageListItem';
import VegsperringListItem from './VegsperringListItem';
import VarutsattVegListItem from './VarutsattVegListItem';
import MeasurementSiteListItem from './MeasurementSiteListItem';
import JernbanekryssingMedSaerskiltFareListItem from './JernbanekryssingMedSaerskiltFareListItem';
import TunnelListItem from './TunnelListItem';
import MissingBruksklasseListItem from "./MissingBruksklasseListItem";
import SpesielleBegrensningerBruksklasseListItem from "./SpesielleBegrensningerBruksklasseListItem";
import { IRoadFeatureResponseListProps } from "./RoadFeatureResponseList";
import SpesialTransportVeggrupperListItem from "./SpesialTransportVeggrupperListItem";
import SpesielleBegrensningerMaksVogntogLengdeListItem from "./SpesielleBegrensningerMaksVogntogLengdeListItem";
import { useCallback } from "react";
import GjennomkjoringForbudtListItem from "./GjennomkjoringForbudtListItem";
import TrafikkreguleringListItem from "./TrafikkreguleringListItem";


export default function RoadFeatureResponseWithBruksklasseList(props: IRoadFeatureResponseListProps) {
    const highlighter = useRouteHighlightActions();
    
    const onMouseEnterItem = useCallback((item: PointRoadFeature) => {
        if(item.location == null) {
                return;
        }
    
        if(item.location.geometry != null && 
            item.location.geometry.type !== undefined && 
            item.location.geometry.type === GeoJsonGeometryType.LINE_STRING) {
            highlighter.setRoadFeatureHighlightLine(item.location.geometry);

        } else {
            highlighter.setRouteDescriptionHighlightFeature(item);
        }
    }, [highlighter]);

    const onMouseLeaveItem = useCallback(() => {
        highlighter.setRouteDescriptionHighlightFeature(null);
        highlighter.setRoadFeatureHighlightLine(null);
    }, [highlighter]);


    if(props.roadFeatureResponse === undefined) {
        return(<List/>)
    }

    return (
        <List
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            sx={{
            width: '100%'
            }}>
            
            <BomstasjonListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <RasteplassListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <VegkameraListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <HeightListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <DognhvileplassListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <LengthListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <TuristvegListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <WeightListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <FergeListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <LadestasjonListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <TrafficMessageListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <SwedishTrafficMessageListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <FinnishTrafficMessageListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <VegsperringListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <VarutsattVegListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <MeasurementSiteListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <JernbanekryssingMedSaerskiltFareListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <TunnelListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>      
            <GjennomkjoringForbudtListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>      
            <TrafikkreguleringListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <MissingBruksklasseListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <SpesielleBegrensningerBruksklasseListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <SpesielleBegrensningerMaksVogntogLengdeListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            <SpesialTransportVeggrupperListItem roadFeatureResponse={props.roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={onMouseEnterItem} onMouseLeaveItem={onMouseLeaveItem}/>
            </List>
    )
}
